import React, { lazy } from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative flex flex-col items-center justify-center px-4 pt-14 pb-8 md:pt-20 md:pb-12 overflow-hidden" data-id="element-52">
      {/* Subtle ambient glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] rounded-full bg-[#d4a853]/5 blur-[120px] pointer-events-none" data-id="element-53" />

      <div className="relative z-10 max-w-4xl mx-auto text-center" data-id="element-54">
        {/* Pre-headline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-[#d4a853]/80 text-sm md:text-base tracking-widest uppercase mb-4 md:mb-5" data-id="element-55">
          Para Creadores, Emprendedores y Dueños de Negocios que se sienten
          invisibles en las redes sociales...
        </motion.p>

        {/* Main Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="font-playfair text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold leading-tight text-white gold-text-shadow mb-4 md:mb-6" data-id="element-56">
          Cómo Dominar el Arte de los Anuncios Cinematográficos en 15 Minutos...{' '}
          <span className="text-[#d4a853]" data-id="element-57">
            Sin Cámaras de $5,000, Sin Modelos y Sin Experiencia en Diseño.
          </span>
        </motion.h1>

        {/* VSL Video */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.6
      }} className="max-w-3xl mx-auto mb-6 md:mb-8" data-id="element-58">
          <div className="relative border border-[#1a1a1a] rounded-sm overflow-hidden" style={{
          paddingTop: '56.25%'
        }} data-id="element-59">
            <iframe src="https://embed.fliki.ai/embed/69feb37f6fb6fe39ab767832" loading="lazy" style={{
            border: 0,
            position: 'absolute',
            top: 0,
            height: '100%',
            width: '100%'
          }} allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowFullScreen data-id="element-60" />
          </div>
        </motion.div>

        {/* Sub-headline */}
        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.7,
        delay: 0.8
      }} className="text-gray-300 text-base md:text-xl leading-relaxed max-w-3xl mx-auto mb-6 md:mb-8" data-id="element-61">
          Descubre el{' '}
          <span className="text-white font-semibold" data-id="element-62">
            Protocolo Nano-Creative Labs
          </span>
          : El sistema de ingeniería visual que transforma texto simple en
          piezas de cine digital que detienen el pulgar, disparan los clics y
          venden a nivel Dios.
        </motion.p>

        {/* Book Image */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.9,
        delay: 0.9
      }} className="relative mb-6 md:mb-8" data-id="element-63">
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none" data-id="element-64">
            <div className="w-64 h-64 md:w-80 md:h-80 rounded-full bg-[#d4a853]/8 blur-[80px]" data-id="element-65" />
          </div>
          <img src="https://cdn.magicpatterns.com/uploads/gSF2vXRe6qeZsfde2hd5jZ/mk-01.png" alt="Nano-Creative Bible" loading="eager" className="relative z-10 mx-auto w-48 md:w-64 lg:w-72 drop-shadow-2xl" data-id="element-66" />
        </motion.div>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 1.2
      }} data-id="element-67">
          <CTAButton data-id="element-68" />
        </motion.div>
      </div>
    </section>;
}